// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CaseRow_container__S8noO {
  margin-bottom: 10px;
}

.CaseRow_root_plus_7__\\+3ugz {
  display: flex;
  color: var(--color-theme-10);
  height: 52px;
  cursor: pointer;
  padding-top: 7px;
  padding-bottom: 15px;

}
.CaseRow_root__ZpEzH {
  display: flex;
  color: var(--color-theme-10);
  height: 45px;
  cursor: pointer;
  padding-top: 7px;
  padding-bottom: 15px;
}

.CaseRow_root_inactive__J1BwB {
  background-color: var(--color-bg-caselist-item);
  border: 1px solid var(--color-theme-bright-gray);
}

.CaseRow_root_active__7A9C2 {
  background-color: var(--color-bg-caselist-item-hover);
  box-shadow: 2px 2px 3px var(--color-theme-cloud);
}

.CaseRow_root_inactive__J1BwB:hover {
  background-color: var(--color-bg-caselist-item-hover);
  border: 1px solid var(--color-bg-caselist-item-hover);
}

.CaseRow_left_container__h12Lk {
  width: 60px;
  text-align: center;
  min-width: 60px;
}

.CaseRow_status_date__BpOeE {
  font-size: 10px;
  padding-top: 5px;
}

.CaseRow_middle_container__8FOw- {
  width: 210px;
}

.CaseRow_host_value__WEsb4 {
  width: 220px;
  font-size: 14px;
  letter-spacing: 0.5px;
  font-weight: 400;
}

.CaseRow_price_value_container__dyOT- {
  width: 220px;
  display: block;
  padding-top: 5px;
  font-weight: bold;
  text-align: right;
}

.CaseRow_price_value__Js6Wi {
  display: inline-block;
  padding-right: 10px;
  font-size: 18px;
  width: 125px;
}

.CaseRow_icon__SAFN1 {
  margin: 0 5px;
}
.CaseRow_warning_icon__kaPsu {
  color: var(--color-theme-yellow);
}

.CaseRow_progress_bar_root__DVTmn {
  height: 5px !important;
  background-color: var(--color-bg-caselist-item) !important;
  border: 1px solid var(--color-theme-bright-gray) !important;
  transition: none !important;
}

.CaseRow_progress_bar_bar__Pvr3d {
  background-color: var(--color-theme-blue) !important;
  transition: none !important;
}

.CaseRow_progress_bar_bar_gray__O4e\\+K {
  background: linear-gradient(
    45deg,
    #c7c7c7 25%,
    #2680eb 25%,
    #2680eb 50%,
    #c7c7c7 50%,
    #c7c7c7 75%,
    #2680eb 75%,
    #2680eb 100%
  ) !important;
  background-size: 15.57px 17.57px !important;
  transition: none !important;
}

.CaseRow_total_value__rLOiH {
  display: inline-block;
  padding-right: 20px;
  font-size: 16px;
  margin-top: -7px;
}

.CaseRow_right_container__c8iEK {
  width: 60px;
  margin-left: -15px;
  min-width: 60px;
}

.CaseRow_right_icon_container__S9ari {
  text-align: center;
}

.CaseRow_callback_icon__nwnex {
  color: var(--color-font-red);
}

.CaseRow_callback_date__HhWPQ {
  font-size: 10px;
  padding-top: 5px;
}

.CaseRow_right_icon_container__S9ari {
  text-align: center;
}

.CaseRow_view_date__UhtoB {
  font-size: 10px;
  padding-top: 5px;
}

.CaseRow_empty__WKrdt {
  width: 60px;
  text-align: center;
  min-width: 60px;
}

.CaseRow_license_icon_container__2fl1E {
  display: inline-block;
  width: 45px;
  text-align: right;
}

.CaseRow_license_icon__zWEDu {
  color: var(--color-theme-blue);
}

.CaseRow_license_icon__zWEDu svg {
  height: 16px;
}

.CaseRow_host_url__ChfGI {
  display: inline-block;
  width: 175px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.CaseRow_curr_sign__CAn8g {
  font-size: 10px;
}

.CaseRow_unread_marker__7fyJD {
  border-radius: 10px;
  width: 7px;
  /* z-index: 20; */
  height: 7px;
  background-color: royalblue;
  position: relative;
  top: -29px;
  left: 25px;
  margin-bottom: -7px;
}

.CaseRow_email_marker_alone__yoBBb {
}
`, "",{"version":3,"sources":["webpack://./src/@_components/CaseRow/CaseRow.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;;AAEtB;AACA;EACE,aAAa;EACb,4BAA4B;EAC5B,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,+CAA+C;EAC/C,gDAAgD;AAClD;;AAEA;EACE,qDAAqD;EACrD,gDAAgD;AAClD;;AAEA;EACE,qDAAqD;EACrD,qDAAqD;AACvD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;AACf;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,0DAA0D;EAC1D,2DAA2D;EAC3D,2BAA2B;AAC7B;;AAEA;EACE,oDAAoD;EACpD,2BAA2B;AAC7B;;AAEA;EACE;;;;;;;;;cASY;EACZ,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,iBAAiB;EACjB,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,mBAAmB;AACrB;;AAEA;AACA","sourcesContent":[".container {\n  margin-bottom: 10px;\n}\n\n.root_plus_7 {\n  display: flex;\n  color: var(--color-theme-10);\n  height: 52px;\n  cursor: pointer;\n  padding-top: 7px;\n  padding-bottom: 15px;\n\n}\n.root {\n  display: flex;\n  color: var(--color-theme-10);\n  height: 45px;\n  cursor: pointer;\n  padding-top: 7px;\n  padding-bottom: 15px;\n}\n\n.root_inactive {\n  background-color: var(--color-bg-caselist-item);\n  border: 1px solid var(--color-theme-bright-gray);\n}\n\n.root_active {\n  background-color: var(--color-bg-caselist-item-hover);\n  box-shadow: 2px 2px 3px var(--color-theme-cloud);\n}\n\n.root_inactive:hover {\n  background-color: var(--color-bg-caselist-item-hover);\n  border: 1px solid var(--color-bg-caselist-item-hover);\n}\n\n.left_container {\n  width: 60px;\n  text-align: center;\n  min-width: 60px;\n}\n\n.status_date {\n  font-size: 10px;\n  padding-top: 5px;\n}\n\n.middle_container {\n  width: 210px;\n}\n\n.host_value {\n  width: 220px;\n  font-size: 14px;\n  letter-spacing: 0.5px;\n  font-weight: 400;\n}\n\n.price_value_container {\n  width: 220px;\n  display: block;\n  padding-top: 5px;\n  font-weight: bold;\n  text-align: right;\n}\n\n.price_value {\n  display: inline-block;\n  padding-right: 10px;\n  font-size: 18px;\n  width: 125px;\n}\n\n.icon {\n  margin: 0 5px;\n}\n.warning_icon {\n  color: var(--color-theme-yellow);\n}\n\n.progress_bar_root {\n  height: 5px !important;\n  background-color: var(--color-bg-caselist-item) !important;\n  border: 1px solid var(--color-theme-bright-gray) !important;\n  transition: none !important;\n}\n\n.progress_bar_bar {\n  background-color: var(--color-theme-blue) !important;\n  transition: none !important;\n}\n\n.progress_bar_bar_gray {\n  background: linear-gradient(\n    45deg,\n    #c7c7c7 25%,\n    #2680eb 25%,\n    #2680eb 50%,\n    #c7c7c7 50%,\n    #c7c7c7 75%,\n    #2680eb 75%,\n    #2680eb 100%\n  ) !important;\n  background-size: 15.57px 17.57px !important;\n  transition: none !important;\n}\n\n.total_value {\n  display: inline-block;\n  padding-right: 20px;\n  font-size: 16px;\n  margin-top: -7px;\n}\n\n.right_container {\n  width: 60px;\n  margin-left: -15px;\n  min-width: 60px;\n}\n\n.right_icon_container {\n  text-align: center;\n}\n\n.callback_icon {\n  color: var(--color-font-red);\n}\n\n.callback_date {\n  font-size: 10px;\n  padding-top: 5px;\n}\n\n.right_icon_container {\n  text-align: center;\n}\n\n.view_date {\n  font-size: 10px;\n  padding-top: 5px;\n}\n\n.empty {\n  width: 60px;\n  text-align: center;\n  min-width: 60px;\n}\n\n.license_icon_container {\n  display: inline-block;\n  width: 45px;\n  text-align: right;\n}\n\n.license_icon {\n  color: var(--color-theme-blue);\n}\n\n.license_icon svg {\n  height: 16px;\n}\n\n.host_url {\n  display: inline-block;\n  width: 175px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.curr_sign {\n  font-size: 10px;\n}\n\n.unread_marker {\n  border-radius: 10px;\n  width: 7px;\n  /* z-index: 20; */\n  height: 7px;\n  background-color: royalblue;\n  position: relative;\n  top: -29px;\n  left: 25px;\n  margin-bottom: -7px;\n}\n\n.email_marker_alone {\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CaseRow_container__S8noO`,
	"root_plus_7": `CaseRow_root_plus_7__+3ugz`,
	"root": `CaseRow_root__ZpEzH`,
	"root_inactive": `CaseRow_root_inactive__J1BwB`,
	"root_active": `CaseRow_root_active__7A9C2`,
	"left_container": `CaseRow_left_container__h12Lk`,
	"status_date": `CaseRow_status_date__BpOeE`,
	"middle_container": `CaseRow_middle_container__8FOw-`,
	"host_value": `CaseRow_host_value__WEsb4`,
	"price_value_container": `CaseRow_price_value_container__dyOT-`,
	"price_value": `CaseRow_price_value__Js6Wi`,
	"icon": `CaseRow_icon__SAFN1`,
	"warning_icon": `CaseRow_warning_icon__kaPsu`,
	"progress_bar_root": `CaseRow_progress_bar_root__DVTmn`,
	"progress_bar_bar": `CaseRow_progress_bar_bar__Pvr3d`,
	"progress_bar_bar_gray": `CaseRow_progress_bar_bar_gray__O4e+K`,
	"total_value": `CaseRow_total_value__rLOiH`,
	"right_container": `CaseRow_right_container__c8iEK`,
	"right_icon_container": `CaseRow_right_icon_container__S9ari`,
	"callback_icon": `CaseRow_callback_icon__nwnex`,
	"callback_date": `CaseRow_callback_date__HhWPQ`,
	"view_date": `CaseRow_view_date__UhtoB`,
	"empty": `CaseRow_empty__WKrdt`,
	"license_icon_container": `CaseRow_license_icon_container__2fl1E`,
	"license_icon": `CaseRow_license_icon__zWEDu`,
	"host_url": `CaseRow_host_url__ChfGI`,
	"curr_sign": `CaseRow_curr_sign__CAn8g`,
	"unread_marker": `CaseRow_unread_marker__7fyJD`,
	"email_marker_alone": `CaseRow_email_marker_alone__yoBBb`
};
export default ___CSS_LOADER_EXPORT___;
